export default __webpack_public_path__ + "static/media/looking-for-seeds.253af9b1.jpg";